import React from 'react';
import classNames from 'classnames';
import style from './index.module.scss';

interface IProps {
	color?: 'purple' | 'darkPurple' | 'red' | 'green' | 'lightGreen' | 'blue';
	size?: 'md' | 'sm';
	className?: string;
	children: React.ReactNode;
}

export const Badge: React.FC<IProps> = ({ color = 'purple', size = 'md', className, children }) => {
	const badgeClasses = classNames(
		style.badge,
		style.variantDefault,
		{
			[style.colorPurple]: color === 'purple',
			[style.colorDarkPurple]: color === 'darkPurple',
			[style.colorRed]: color === 'red',
			[style.colorGreen]: color === 'green',
			[style.colorLightGreen]: color === 'lightGreen',
			[style.colorBlue]: color === 'blue',
			[style.sizeSm]: size === 'sm',
			[style.sizeMd]: size === 'md',
		},
		className,
	);

	return (
		<div className={style.container}>
			<div className={badgeClasses}>{children}</div>
		</div>
	);
};
